// True when a key event should drive the tour: its target sits inside the tour
// overlay and is not something the user types into (eval F43).
export function shouldHandleTourKey(target: EventTarget | null, root: HTMLElement | null): boolean {
  if (!root || !(target instanceof Node) || !root.contains(target)) return false;
  if (target instanceof HTMLElement) {
    if (target.isContentEditable) return false;
    if (target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return false;
  }
  return true;
}
